const lastModuleStorageKey = "ws.lastModuleApp";

export default lastModuleStorageKey;
